export default __webpack_public_path__ + "static/media/nat.d4be41ab.png";